var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndCharge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2091 1H2.29412H2.15293C1.83242 1 1.52851 1.1425 1.32353 1.38889C1.11447 1.64019 1 1.95676 1 2.28365V13.2091C1 13.8377 1.32956 14.4203 1.86834 14.7441C2.14693 14.9115 2.46584 15 2.79088 15H21.2091C21.5342 15 21.8531 14.9115 22.1317 14.7441C22.6704 14.4203 23 13.8377 23 13.2091V3.33333V2.79088C23 2.16228 22.6704 1.57971 22.1317 1.2559C21.8531 1.08846 21.5342 1 21.2091 1Z",
    stroke: "#12B76A",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11C24.5304 11 25.0391 10.6839 25.4142 10.1213C25.7893 9.55871 26 8.79565 26 8C26 7.20435 25.7893 6.44129 25.4142 5.87868C25.0391 5.31607 24.5304 5 24 5L24 8V11Z",
    fill: "#12B76A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13V3C6 1.89543 5.10457 1 4 1C2.89543 1 2 1.89543 2 3V13C2 14.1046 2.89543 15 4 15C5.10457 15 6 14.1046 6 13Z",
    fill: "#12B76A",
    stroke: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCharge);
export default __webpack_public_path__ + "static/media/end-charge.f597abdbc27f3acd6b50ac2964fd5044.svg";
export { ForwardRef as ReactComponent };